import { FCPState, initialFCPState } from "../FCPSlice";

const tasksReseted = (state: FCPState) => {
  state.tasks = initialFCPState.tasks;
};

export default tasksReseted;
